/* For accessing things in onChange events. */

export const all = 0;

export const varName = 0;
export const currID1 = 1;
export const currID2 = 2;

/* countryOL fields */
export const countryOL = "countryOL";
export const countryObjMstID = "mstID";
export const countryObjName = "name";

/* Fields in the mstIDsObj */
export const mstIDsObj = "mstIDsObj";
export const siteMstIDs = "siteMstIDs";
export const displayParamMstIDs = "displayParamMstIDs";
export const stdResultMstIDs = "stdResultMstIDs";
export const indMstIDs = "indMstIDs";
export const catMstIDs = "catMstIDs";

/* Fields in indInfo */
export const indInfo = "indInfo";
export const numItemsPerInd = "numItemsPerInd";
export const indNames = "indNames";
export const indCanGraph = "indCanGraph";
export const indCats = "indCats";
export const indNoDataValues = "indNoDataValues";

/* Fields in catInfo */
export const catInfo = "catInfo";
export const catNames = "catNames";

/* Fields of the year range objects inside of the mostRecentYearRange array. */
export const startMonth = "startMonth";
export const startYear = "startYear";
export const endMonth = "endMonth";
export const endYear = "endYear";
export const monthsForYear = "monthsForYear";

/* monthsForYear constants */
export const loopYear = 1;
export const firstMonthLoop = 2;
export const finalMonthLoop = 3;

/* Fields in siteCharByTimeInfo */
export const siteCharByTimeInfo = "siteCharByTimeInfo";
export const geoTypeNames = "geoTypeNames";
export const servDelivModeNames = "servDelivModeNames";
export const PEPFAR_CatNames = "PEPFAR_CatNames";
export const VMMC_CatNames = "VMMC_CatNames";
export const DREAMS_CatNames = "DREAMS_CatNames";
export const ownershipTypeNames = "ownershipTypeNames";
export const USG_AgencyNames = "USG_AgencyNames";
export const impPartnerNames = "impPartnerNames";
export const geoTypeMstIDs = "geoTypeMstIDs";
export const servDelivModeMstIDs = "servDelivModeMstIDs";
export const PEPFAR_CatMstIDs = "PEPFAR_CatMstIDs";
export const VMMC_CatMstIDs = "VMMC_CatMstIDs";
export const DREAMS_CatMstIDs = "DREAMS_CatMstIDs";
export const ownershipTypeMstIDs = "ownershipTypeMstIDs";
export const USG_AgencyMstIDs = "USG_AgencyMstIDs";
export const impPartnerMstIDs = "impPartnerMstIDs";

/* Fields in the configuration options object. */
export const level = "level";
export const timeInterval = "timeInterval";
export const month = "month";
export const quarter = "quarter";
export const half = "half";
export const year = "year";
export const firstYearTrend = "firstYearTrend";
export const finalYearTrend = "finalYearTrend";
export const graphViewType = "graphViewType";
export const timeIntervalValsAggr = "timeIntervalValsAggr";
export const provincesIncluded = "provincesIncluded";
export const geoTypesIncluded = "geoTypesIncluded";
export const PEPFAR_CatsIncluded = "PEPFAR_CatsIncluded";
export const VMMC_CatsIncluded = "VMMC_CatsIncluded";
export const DREAMS_CatsIncluded = "DREAMS_CatsIncluded";
export const USG_AgenciesIncluded = "USG_AgenciesIncluded";
export const impPartnersIncluded = "impPartnersIncluded";
export const servDelivModesIncluded = "servDelivModesIncluded";
export const ownershipTypesIncluded = "ownershipTypesIncluded";
export const SNUsIncluded = "SNUsIncluded";
export const sitesIncluded = "sitesIncluded";
export const sitesDisplayed = "sitesDisplayed";
export const xAxisVar = "xAxisVar";
export const indsIncluded = "indsIncluded";
export const demandCreationAgeGrp = "demandCreationAgeGrp";
export const graphViewTypeStr = "graphViewTypeStr";
export const provincesStr = "provincesStr";
export const geoTypesStr = "geoTypesStr";
export const PEPFAR_CatsStr = "PEPFAR_CatsStr";
export const VMMC_CatsStr = "VMMC_CatsStr";
export const DREAMS_CatsStr = "DREAMS_CatsStr";
export const USG_AgenciesStr = "USG_AgenciesStr";
export const impPartnersStr = "impPartnersStr";
export const servDelivModesStr = "servDelivModesStr";
export const ownershipTypesStr = "ownershipTypesStr";
export const SNUsStr = "SNUsStr";
export const sitesStr = "sitesStr";

export const countryCodeMozambique = 508;
export const countryCodeSwaziland = 748;
export const countryCodeTanzania = 834;
export const countryCodeSampleCountry = 5833; // should actually be 5733, but takes coordination to change...

/* Page IDs */
export const SCResultsFormPg = "SCResultsForm";
export const SCWelcomeFormPg = "SCWelcomeForm";

/* Drawer constants */
export const resultsDrawer = "SCResultsDrawer";
export const locationsDrawer = "SCLocationsDrawer";
export const characteristicsDrawer = "SCCharacteristicsDrawer";
export const sitesDrawer = "SCSitesDrawer";
export const timePeriodDrawer = "SCTimePeriodDrawer";
export const editTemplateDrawer = "SCEditTemplateDrawer";

/* configExtra: for fields not in the configuration options object. */
export const resultPlotType = "resultPlotType";
/* Does not refer to chartType from configuration options object on server, so
   named it differently to differentiate. */
export const chartTypeClient = "chartTypeClient";
export const resultID = "resultID";
export const displays = "displays";
export const displaysStr = "displaysStr";
export const indicators = "indicators";

/* data object (DO) fields */
export const extraDimDO = "extraDim";
export const monthDO = "month";
export const valueDO = "value";
export const yearIdxDO = "yearIdx";

/* Plot type constants for resultPlotType field. */
export const standardPlotType = 1;
export const flexiblePlotType = 2;

/* Chart types */
export const line = 1;
export const bar = 2;
export const table = 3;
export const dualAxis = 4;

/* Graph view type */
export const trendView = 1;
export const aggregateView = 2;

/* X-axis variable */
export const xAxisLevel = 1;
export const xAxisTime = 2;

/* Levels/Locations */
export const siteLevel = 1;
export const SNU_Level = 2;
export const provinceLevel = 3;

/* Master category IDs for organizing results and indicators. */
export const cat_SetupMstID = 1;
export const cat_CharMstID = 2;
export const cat_PersFacMstID = 3;
export const cat_SiteCapMstID = 4;
export const cat_DemandMstID = 5;
export const cat_STIsHIVMstID = 6;
export const cat_VMMC_ServDelivMstID = 7;
export const cat_SiteProdMstID = 8;

/* Master standard result IDs */

export const addStaffNeededOptOpResMstID = 1;
export const VMMCDailySiteCapResMstID = 2;
export const VMMCSiteCapResMstID = 3;
export const VMMCSitesTargCapDoneResMstID = 4;
export const totalVMMCDoneResMstID = 5;
export const totalVMMCTargetBySiteResMstID = 6;
export const VMMCDoneBySiteResMstID = 7;
export const VMMCDoneByAgeAndSiteResMstID = 8;
export const VMMCDoneAgeGroupsAndRates15PlusResMstID = 9;
export const VMMCDoneByAgeGroupsResMstID = 10;
export const VMMCDoneBySurgicalMethodsResMstID = 11;
export const VMMCDoneByAgeGroupResMstID = 12;
export const fllwUpRateBySiteResMstID = 13;
export const advEventsRateBySevResMstID = 14;
export const STI_RefBySiteResMstID = 15;
export const numHIVTestDoneUptakeResMstID = 16;
export const numHIVPosRateResMstID = 17;
export const enrollCareTrRateResMstID = 18;
export const performAgainstTargetResMstID = 19;
export const siteUtilRateBySiteResMstID = 20;
export const dailyProdIdxBySiteResMstID = 21;
export const monthlyProdIdxBySiteResMstID = 22;
export const demandCreationResMstID = 23;
export const overallPerformResMstID = 24;
export const VMMCDoneResMstID = 25;
export const VMMCDoneByAGResMstID = 26;
export const VMMCDoneBySimpleAGResMstID = 27;
export const VMMCDoneBySurgMethodResMstID = 28;
export const VMMCDoneOverTimeResMstID = 29;
export const customResMstID = 30;

/* Master indicator IDs */

export const geoTypeIndMstID = 1;
export const servDelivModeIndMstID = 2;
export const openingDateIndMstID = 3;
export const closingDateIndMstID = 4;
export const ownershipTypeIndMstID = 5;
export const PEPFAR_CatIndMstID = 6;
export const VMMC_CatIndMstID = 7;
export const DREAMS_CatIndMstID = 8;
export const USG_AgencyIndMstID = 9;
export const impPartnerIndMstID = 10;
export const taskShiftServDelivIndMstID = 11;
export const moveServDelivIndMstID = 12;
export const numSurgBedsIndMstID = 13;
export const currNumProvidersIndMstID = 14;
export const currNumAssistantsIndMstID = 15;
export const currNumNursesIndMstID = 16;
export const currNumCounsIndMstID = 17;
export const daysOfOpIndMstID = 18;
export const currNumVMMC_DailyIndCMstID = 19;
export const currNumVMMCIndCMstID = 20;
export const optNumVMMCIndCMstID = 21;
export const targNumCircumIndMstID = 22;
export const VMMC_DoneIndMstID = 23;
export const surgMethodIndMstID = 24;
export const adverseEventsIndMstID = 25;
export const followUpIndMstID = 26;
export const VMMC_BedRateIndCMstID = 27;
export const dailyProdIdxIndCMstID = 28;
export const currNumMobilIndMstID = 29;
export const numReachedByMobilIndMstID = 30;
export const numSeekingVMMC_ServIndMstID = 31;
export const infoSourcesIndMstID = 32;
export const STIPosIndMstID = 33;
export const STITreatCircumIndMstID = 34;
export const enrolledCAndTIndMstID = 35;
export const HIVTestDoneIndMstID = 36;
export const HIVPosIndMstID = 37;
export const HIV_PosRateIndCMstID = 38;
export const VMMC_DoneIndCMstID = 39;
export const VMMC_DoneOverTimeIndIndCMstID = 40;
export const VMMC_DoneByAGIndCMstID = 41;
export const VMMC_DoneSimpleAGIndCMstID = 42;
export const followUpRateIndCMstID = 43;
export const optNumVMMC_DailyIndCMstID = 44;
export const dailyVMMC_DoneIndCMstID = 45;
export const percReachedByMobilIndMstID = 46;
export const monthlyProdIdxIndCMstID = 47;
export const optUtilizationRateIndCMstID = 48;
export const currUtilizationRateIndCMstID = 49;
export const performAgainstTargetIndCMstID = 50;
export const percVMMC_PerReachMobilIndCMstID = 51;
export const percSTI_PosIndCMstID = 52;
export const numSTI_TreatedIndCMstID = 53;
export const uptakeHIV_TestingIndCMstID = 54;
export const HIVTestDoneIndCMstID = 55;
export const advEventsRateBySevIndMstID = 56;
export const anyAdvEventsRateIndCMstID = 57;
export const enrollCareTrRateIndCMstID = 58;
export const siteClosedIndMstID = 59;
export const VMMC_DoneResIndCMstID = 60;
export const VMMC_DoneOverTimeResIndCMstID = 61;
export const HIVTestDoneResIndCMstID = 62;
export const advEventsRateBySevIndCMstID = 63;
export const addProvidersNeededIndCMstID = 64;
export const addAssistantsNeededIndCMstID = 65;
export const addNursesNeededIndCMstID = 66;
export const addMobilisersNeededIndCMstID = 67;
export const addCounsellorsNeededIndCMstID = 68;
export const percPotVMMC_ClientsBySrcInfoIndCMstID = 69;

/* Display parameter master IDs from server */
export const canBeLineGraphMstID = 13;
export const canBeBarGraphMstID = 14;
export const timeType1MstID = 15;
export const dualAxesResultMstID = 16;

/* Time intervals */
export const monthly = 1;
export const quarterly = 2;
export const biAnnually = 3;
export const annually = 4;

export const firstPeriod = 1;
export const finalPeriod = 2;

export const firstPossibleYear = 2010;

export const LT15DC = 1;
export const ageGroupPlusDC = 2;
export const allAgesDC = 3;

export const noData = -1;

/* VMMC age group master IDs for accessing specific age groups. */
export const age10t14MstID = 1;
export const age15t19MstID = 2;
export const age20t24MstID = 3;
export const age25t29MstID = 4;
export const age30PlusMstID = 5;
export const age1t9MstID = 6;
export const age30t34MstID = 7;
export const age35t39MstID = 8;
export const age40t44MstID = 9;
export const age45t49MstID = 10;
export const age50PlusMstID = 11;
export const ageLT2MoMstID = 12;
export const age1t4MstID = 13;
export const age5t9MstID = 14;

/* Information sources master IDs for accessing specific information sources. */

export const TVMstID = 1;
export const radioMstID = 2;
export const friendMstID = 3;
export const familyMstID = 4;
export const mobilisersMstID = 5;
export const communityLeadersMstID = 6;
export const postersMstID = 7;
export const healthWorkersMstID = 8;
export const numInfoSources = healthWorkersMstID;

/* Follow up period master IDs for accessing specific follow up periods. */

export const period48HrsMstID = 1;
export const period7DaysMstID = 2;
export const period6WeeksMstID = 3;
export const numPeriods = period6WeeksMstID;

/* Adverse events severity master IDs for accessing specific adverse event severities. */

export const mildMstID = 1;
export const moderateMstID = 2;
export const severeMstID = 3;
export const numAdverseEvents = severeMstID;

/* styles: object with a variety of styles to use for different Components

   container: used to control the height of the area that groups of Components are in.
   category: used for groups of characteristics, such as PEPFAR categories. */
export const styles = {
    levelContainer: {
        height: "calc(100% - " + 0 + "px) / 3",
    },
    container: {
        height: "calc(100% - " + 0 + "px)",
    },
    category: {
        float: "left",
        verticalAlign: "top",
        height: "230px",
        padding: "20px",
        width: "150px",
    },
    label: {
        marginBottom: 10,
    },
    checkboxes: {
        paddingLeft: 20,
    },
    saveBtnDiv: {
        position: "absolute",
        top: 15,
        right: 100,
    },
    closeBtnDiv: {
        position: "absolute",
        top: 10,
        left: 10,
    },
    combobox: {
        width: 200,
    },
};
